import { Pipe, PipeTransform } from '@angular/core';
import { IAvailableStatus } from '@x/ecommerce-shop/app/core/availability/availability';
import { TShopPillColor } from '@x/ecommerce-shop/app/core/shop-ui/components/shop-pill/shop-pill.component';

@Pipe({
  name: 'availabilityColor',
  standalone: true,
})
export class AvailabilityColorPipe implements PipeTransform {
  warnColorStatus: IAvailableStatus[] = [
    'PRE_ORDER',
    'LOW_STOCK_URGENCY',
    'LAST_CHANCE_AVAILABILITY',
  ];

  transform(value: IAvailableStatus): TShopPillColor {
    return this.warnColorStatus.includes(value) ? 'warn' : 'default';
  }
}
